import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { MachinesService } from '../services/machines.service';

@Component({
  selector: 'ngx-new-machine',
  templateUrl: './new-machine.component.html',
  styleUrls: ['./new-machine.component.scss'],
})
export class NewMachineComponent implements OnInit {
  @Input() stationId: string;
  linearMode = true;

  equipment = {
    name: '',
    brand: '',
    fabricationYear: '',
    manufacturer: '',
    location: '',
    idKey: '',
    model: '',
    serial: '',
    lastCalibrationDate: new Date,
    nextCalbrationDate: new Date(),
    voltage: '',
    flow: '',
    frequency: '',
    power: '',
    capacity: '',
    weigth: '',
    powerSupply: '',
    characteristics: {
      electric: false,
      neumatic: false,
      hidraulic: false,
      electronic: false,
      mechanic: false,
      informatic: false,
      termic: false,
    },
    engines: [
      {
        engine: '',
        description: '',
        code: '',
        brand: '',
        model: '',
        serie: '',
        powerSupply: '',
        hp: '',
        rpm: '',
        voltage: '',
        amperage: '',
      },
    ],
  };

  toggleLinearMode() {
    this.linearMode = !this.linearMode;
  }

  constructor(
    protected ref: NbDialogRef<NewMachineComponent>,
    private machineService: MachinesService,
  ) { }

  async saveMachine() {
    const [error] = await this.machineService.storeEquipment(this.stationId, this.equipment);
    // tslint:disable-next-line: max-line-length
    if (error) return this.alert('Ocurrio un error al intentar guardar la información, intenta más tarde por favor', 'error');
    this.alert('Equipo guardado con éxito');
    this.ref.close(true);
  }


  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  ngOnInit() {
  }

  close() {
    this.ref.close();
  }
}
